import { useState, useEffect } from "react";
import { useLang } from "../context/LanguageContext";
import { t } from "../data/translations";
import styles from "./CookieConsent.module.css";

const CookieConsent = () => {
  const { lang } = useLang();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    } else if (consent === "true") {
      enableAnalytics();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "true");
    enableAnalytics();
    setShowBanner(false);
  };

  const enableAnalytics = () => {
    if (!window.gtag) {
      const script1 = document.createElement("script");
      script1.setAttribute("async", "");
      script1.src = "https://www.googletagmanager.com/gtag/js?id=G-8WFC0RR00R";
      document.head.appendChild(script1);

      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-8WFC0RR00R');
      `;
      document.head.appendChild(script2);
    }
  };

  if (!showBanner) return null;

  return (
    <div className={styles.banner}>
      <p>
        {t("cookie.text", lang)}{" "}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">
          {t("cookie.learnMore", lang)}
        </a>
      </p>
      <button onClick={acceptCookies}>{t("cookie.accept", lang)}</button>
    </div>
  );
};

export default CookieConsent;
